/* Stop the page downloading full-resolution photos into thumbnail-sized boxes.

   MEASURED on the live PDP, 11 Aug: each of the three bundle cards loaded the serum photo
   at its natural 1856px width into an 84px box — a 22x oversample, roughly 300KB each to
   paint something the size of a fingernail.

   Two symptoms, one cause:
     - the page felt slow on mobile
     - the bundle cards showed broken-image placeholders on a phone. They were not broken;
       they were still downloading, and Safari paints the broken glyph in the meantime.
       Desktop audits reported "0 broken" because a fast connection finished the download
       before the check ran. That is why this went unnoticed for so long — probing after a
       forced full load hides exactly this class of bug.

   Shopify's CDN resizes on demand, so we simply ask for the size actually being displayed
   (2x for retina, floor 200px).

   THE SEPARATOR MATTERS. Appending "&width=" to a URL with no "?" produces an invalid URL
   and the image silently 404s. That bug has bitten this store three separate times — the
   dropdown, the homepage hero and the whole collection page. Always test for "?" first.
   Only Shopify CDN URLs are touched, and never one that already carries a width. */
(function(){
  var FLOOR = 200, MAX = 1200;

  function resize(img){
    var src = img.getAttribute('src') || '';
    if (!src) return;
    if (!/cdn\.shopify\.com/.test(src)) return;      /* only Shopify's resizer */
    if (/[?&]width=/.test(src)) return;               /* already sized */
    var box = Math.round(img.getBoundingClientRect().width);
    if (!box) return;                                 /* not laid out yet */
    var want = Math.min(MAX, Math.max(FLOOR, box * 2));   /* 2x for retina */
    var sep = src.indexOf('?') > -1 ? '&' : '?';      /* see note above */
    img.setAttribute('src', src + sep + 'width=' + want);
  }

  function run(){
    document.querySelectorAll(
      '.lp .bcard img, .lp .bimg img, .lp .thumbs .t img, .lp .lncard img, .lnim img'
    ).forEach(resize);
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  [200, 700, 1600, 3000].forEach(function(d){ setTimeout(run, d); });

  function observe(){
    if (!document.body) return;
    var q = false;
    new MutationObserver(function(){
      if (q) return; q = true;
      requestAnimationFrame(function(){ q = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) observe(); else document.addEventListener('DOMContentLoaded', observe);
})();